import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "modal", "form", "modalTitle", "hasAccess", "rolesSelect", "rolesContainer"
  ];

  connect() {
    if (this.hasHasAccessTarget && this.hasRolesContainerTarget) {
      this.toggleRolesSelect();
    }
  }

  toggleRolesSelect() {
    if (this.hasHasAccessTarget && this.hasRolesContainerTarget) {
      if (this.hasAccessTarget.checked) {
        this.rolesContainerTarget.classList.remove("hidden");
      } else {
        this.rolesContainerTarget.classList.add("hidden");
      }
    }
  }

  openModal(event) {
    event.preventDefault();

    // Reset the form if it exists
    if (this.hasFormTarget) {
      this.formTarget.reset();
    }

    // Change the title for new record
    this.modalTitleTarget.textContent = "New Staff Member";

    // Fetch the new form
    fetch("/schools/school_staffs/new", {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((response) => response.text())
      .then((html) => {
        const sideSheet = document.getElementById("side_sheet");
        if (sideSheet) {
          sideSheet.innerHTML = html;
        }
      });

    // Show the modal
    this.modalTarget.classList.remove("hidden");
  }

  closeModal(event) {
    event.preventDefault();
    this.modalTarget.classList.add("hidden");

    // Clear the side sheet content
    const sideSheet = document.getElementById("side_sheet");
    if (sideSheet) {
      sideSheet.innerHTML = "";
    }
  }

  editStaff(event) {
    event.preventDefault();

    const url = event.currentTarget.getAttribute("href");

    // Change the title for editing
    this.modalTitleTarget.textContent = "Edit Staff Member";

    // Fetch the edit form
    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((response) => response.text())
      .then((html) => {
        const sideSheet = document.getElementById("side_sheet");
        if (sideSheet) {
          sideSheet.innerHTML = html;
        }
      });

    // Show the modal
    this.modalTarget.classList.remove("hidden");
  }

  showStaff(event) {
    event.preventDefault();

    const url = event.currentTarget.getAttribute("href");

    // Change the title to show
    this.modalTitleTarget.textContent = "Staff Details";

    // Fetch the show view
    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((response) => response.text())
      .then((html) => {
        const sideSheet = document.getElementById("side_sheet");
        if (sideSheet) {
          sideSheet.innerHTML = html;
        }
      });

    // Show the modal
    this.modalTarget.classList.remove("hidden");
  }

}
